import { CustomField, Workspace, WorkspaceConnection } from "@web-app/types";
import http from "@web-app/utils/http";

export type CreateConnectionPayload = {
  avatarUrl: string | null;
  name: string;
};

export const create = (
  currentWorkspaceId: string,
  payload: CreateConnectionPayload,
) => {
  return http
    .post<Workspace>(`/workspaces/${currentWorkspaceId}/connections`, payload)
    .then((response) => response.data);
};

export const get = (currentWorkspaceId: string) => {
  return http
    .get<WorkspaceConnection[]>(`/workspaces/${currentWorkspaceId}/connections`)
    .then((response) => response.data);
};

export const getCustomFields = (workspaceIds: string[]) => {
  return http
    .get<CustomField[]>(
      `/workspace/customFields?workspaceIds=${workspaceIds.join(",")}`,
    )
    .then((response) => response.data);
};
